/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.Lobby = (function() {

    /**
     * Namespace Lobby.
     * @exports Lobby
     * @namespace
     */
    var Lobby = {};

    /**
     * LobbyPacketID enum.
     * @name Lobby.LobbyPacketID
     * @enum {number}
     * @property {number} NONE=0 NONE value
     * @property {number} PACKET_RS_REPLY=1 PACKET_RS_REPLY value
     * @property {number} PACKET_RQ_PING=11 PACKET_RQ_PING value
     * @property {number} PACKET_RS_PING=12 PACKET_RS_PING value
     * @property {number} PACKET_MC_BALANCE_CHANGE=13 PACKET_MC_BALANCE_CHANGE value
     * @property {number} PACKET_MC_NEW_EMAIL=14 PACKET_MC_NEW_EMAIL value
     * @property {number} PACKET_MC_LOGINOUT=15 PACKET_MC_LOGINOUT value
     * @property {number} PACKET_MC_TASK_FINISH=16 PACKET_MC_TASK_FINISH value
     * @property {number} PACKET_MC_CONFIG_CHANGE=17 PACKET_MC_CONFIG_CHANGE value
     * @property {number} PACKET_MC_BET_GAME_NOTIFY=18 PACKET_MC_BET_GAME_NOTIFY value
     * @property {number} PACKET_MC_INSUFFICIENT_BALANCE=19 PACKET_MC_INSUFFICIENT_BALANCE value
     */
    Lobby.LobbyPacketID = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NONE"] = 0;
        values[valuesById[1] = "PACKET_RS_REPLY"] = 1;
        values[valuesById[11] = "PACKET_RQ_PING"] = 11;
        values[valuesById[12] = "PACKET_RS_PING"] = 12;
        values[valuesById[13] = "PACKET_MC_BALANCE_CHANGE"] = 13;
        values[valuesById[14] = "PACKET_MC_NEW_EMAIL"] = 14;
        values[valuesById[15] = "PACKET_MC_LOGINOUT"] = 15;
        values[valuesById[16] = "PACKET_MC_TASK_FINISH"] = 16;
        values[valuesById[17] = "PACKET_MC_CONFIG_CHANGE"] = 17;
        values[valuesById[18] = "PACKET_MC_BET_GAME_NOTIFY"] = 18;
        values[valuesById[19] = "PACKET_MC_INSUFFICIENT_BALANCE"] = 19;
        return values;
    })();

    Lobby.Lobby = (function() {

        /**
         * Properties of a Lobby.
         * @memberof Lobby
         * @interface ILobby
         */

        /**
         * Constructs a new Lobby.
         * @memberof Lobby
         * @classdesc Represents a Lobby.
         * @implements ILobby
         * @constructor
         * @param {Lobby.ILobby=} [properties] Properties to set
         */
        function Lobby(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Lobby instance using the specified properties.
         * @function create
         * @memberof Lobby.Lobby
         * @static
         * @param {Lobby.ILobby=} [properties] Properties to set
         * @returns {Lobby.Lobby} Lobby instance
         */
        Lobby.create = function create(properties) {
            return new Lobby(properties);
        };

        /**
         * Encodes the specified Lobby message. Does not implicitly {@link Lobby.Lobby.verify|verify} messages.
         * @function encode
         * @memberof Lobby.Lobby
         * @static
         * @param {Lobby.ILobby} message Lobby message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Lobby.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified Lobby message, length delimited. Does not implicitly {@link Lobby.Lobby.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Lobby.Lobby
         * @static
         * @param {Lobby.ILobby} message Lobby message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Lobby.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Lobby message from the specified reader or buffer.
         * @function decode
         * @memberof Lobby.Lobby
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Lobby.Lobby} Lobby
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Lobby.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Lobby.Lobby();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Lobby message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Lobby.Lobby
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Lobby.Lobby} Lobby
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Lobby.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Lobby message.
         * @function verify
         * @memberof Lobby.Lobby
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Lobby.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a Lobby message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Lobby.Lobby
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Lobby.Lobby} Lobby
         */
        Lobby.fromObject = function fromObject(object) {
            if (object instanceof $root.Lobby.Lobby)
                return object;
            return new $root.Lobby.Lobby();
        };

        /**
         * Creates a plain object from a Lobby message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Lobby.Lobby
         * @static
         * @param {Lobby.Lobby} message Lobby
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Lobby.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Lobby to JSON.
         * @function toJSON
         * @memberof Lobby.Lobby
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Lobby.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Lobby
         * @function getTypeUrl
         * @memberof Lobby.Lobby
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Lobby.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/Lobby.Lobby";
        };

        Lobby.ReplyRs = (function() {

            /**
             * Properties of a ReplyRs.
             * @memberof Lobby.Lobby
             * @interface IReplyRs
             * @property {string|null} [message] ReplyRs message
             */

            /**
             * Constructs a new ReplyRs.
             * @memberof Lobby.Lobby
             * @classdesc Represents a ReplyRs.
             * @implements IReplyRs
             * @constructor
             * @param {Lobby.Lobby.IReplyRs=} [properties] Properties to set
             */
            function ReplyRs(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ReplyRs message.
             * @member {string} message
             * @memberof Lobby.Lobby.ReplyRs
             * @instance
             */
            ReplyRs.prototype.message = "";

            /**
             * Creates a new ReplyRs instance using the specified properties.
             * @function create
             * @memberof Lobby.Lobby.ReplyRs
             * @static
             * @param {Lobby.Lobby.IReplyRs=} [properties] Properties to set
             * @returns {Lobby.Lobby.ReplyRs} ReplyRs instance
             */
            ReplyRs.create = function create(properties) {
                return new ReplyRs(properties);
            };

            /**
             * Encodes the specified ReplyRs message. Does not implicitly {@link Lobby.Lobby.ReplyRs.verify|verify} messages.
             * @function encode
             * @memberof Lobby.Lobby.ReplyRs
             * @static
             * @param {Lobby.Lobby.IReplyRs} message ReplyRs message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReplyRs.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.message);
                return writer;
            };

            /**
             * Encodes the specified ReplyRs message, length delimited. Does not implicitly {@link Lobby.Lobby.ReplyRs.verify|verify} messages.
             * @function encodeDelimited
             * @memberof Lobby.Lobby.ReplyRs
             * @static
             * @param {Lobby.Lobby.IReplyRs} message ReplyRs message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReplyRs.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ReplyRs message from the specified reader or buffer.
             * @function decode
             * @memberof Lobby.Lobby.ReplyRs
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {Lobby.Lobby.ReplyRs} ReplyRs
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReplyRs.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Lobby.Lobby.ReplyRs();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.message = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ReplyRs message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof Lobby.Lobby.ReplyRs
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {Lobby.Lobby.ReplyRs} ReplyRs
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReplyRs.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ReplyRs message.
             * @function verify
             * @memberof Lobby.Lobby.ReplyRs
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ReplyRs.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.message != null && message.hasOwnProperty("message"))
                    if (!$util.isString(message.message))
                        return "message: string expected";
                return null;
            };

            /**
             * Creates a ReplyRs message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof Lobby.Lobby.ReplyRs
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {Lobby.Lobby.ReplyRs} ReplyRs
             */
            ReplyRs.fromObject = function fromObject(object) {
                if (object instanceof $root.Lobby.Lobby.ReplyRs)
                    return object;
                var message = new $root.Lobby.Lobby.ReplyRs();
                if (object.message != null)
                    message.message = String(object.message);
                return message;
            };

            /**
             * Creates a plain object from a ReplyRs message. Also converts values to other types if specified.
             * @function toObject
             * @memberof Lobby.Lobby.ReplyRs
             * @static
             * @param {Lobby.Lobby.ReplyRs} message ReplyRs
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ReplyRs.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.message = "";
                if (message.message != null && message.hasOwnProperty("message"))
                    object.message = message.message;
                return object;
            };

            /**
             * Converts this ReplyRs to JSON.
             * @function toJSON
             * @memberof Lobby.Lobby.ReplyRs
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ReplyRs.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ReplyRs
             * @function getTypeUrl
             * @memberof Lobby.Lobby.ReplyRs
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ReplyRs.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/Lobby.Lobby.ReplyRs";
            };

            return ReplyRs;
        })();

        Lobby.HeartBetRq = (function() {

            /**
             * Properties of a HeartBetRq.
             * @memberof Lobby.Lobby
             * @interface IHeartBetRq
             */

            /**
             * Constructs a new HeartBetRq.
             * @memberof Lobby.Lobby
             * @classdesc Represents a HeartBetRq.
             * @implements IHeartBetRq
             * @constructor
             * @param {Lobby.Lobby.IHeartBetRq=} [properties] Properties to set
             */
            function HeartBetRq(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new HeartBetRq instance using the specified properties.
             * @function create
             * @memberof Lobby.Lobby.HeartBetRq
             * @static
             * @param {Lobby.Lobby.IHeartBetRq=} [properties] Properties to set
             * @returns {Lobby.Lobby.HeartBetRq} HeartBetRq instance
             */
            HeartBetRq.create = function create(properties) {
                return new HeartBetRq(properties);
            };

            /**
             * Encodes the specified HeartBetRq message. Does not implicitly {@link Lobby.Lobby.HeartBetRq.verify|verify} messages.
             * @function encode
             * @memberof Lobby.Lobby.HeartBetRq
             * @static
             * @param {Lobby.Lobby.IHeartBetRq} message HeartBetRq message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            HeartBetRq.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified HeartBetRq message, length delimited. Does not implicitly {@link Lobby.Lobby.HeartBetRq.verify|verify} messages.
             * @function encodeDelimited
             * @memberof Lobby.Lobby.HeartBetRq
             * @static
             * @param {Lobby.Lobby.IHeartBetRq} message HeartBetRq message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            HeartBetRq.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a HeartBetRq message from the specified reader or buffer.
             * @function decode
             * @memberof Lobby.Lobby.HeartBetRq
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {Lobby.Lobby.HeartBetRq} HeartBetRq
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            HeartBetRq.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Lobby.Lobby.HeartBetRq();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a HeartBetRq message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof Lobby.Lobby.HeartBetRq
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {Lobby.Lobby.HeartBetRq} HeartBetRq
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            HeartBetRq.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a HeartBetRq message.
             * @function verify
             * @memberof Lobby.Lobby.HeartBetRq
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            HeartBetRq.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a HeartBetRq message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof Lobby.Lobby.HeartBetRq
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {Lobby.Lobby.HeartBetRq} HeartBetRq
             */
            HeartBetRq.fromObject = function fromObject(object) {
                if (object instanceof $root.Lobby.Lobby.HeartBetRq)
                    return object;
                return new $root.Lobby.Lobby.HeartBetRq();
            };

            /**
             * Creates a plain object from a HeartBetRq message. Also converts values to other types if specified.
             * @function toObject
             * @memberof Lobby.Lobby.HeartBetRq
             * @static
             * @param {Lobby.Lobby.HeartBetRq} message HeartBetRq
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            HeartBetRq.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this HeartBetRq to JSON.
             * @function toJSON
             * @memberof Lobby.Lobby.HeartBetRq
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            HeartBetRq.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for HeartBetRq
             * @function getTypeUrl
             * @memberof Lobby.Lobby.HeartBetRq
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            HeartBetRq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/Lobby.Lobby.HeartBetRq";
            };

            return HeartBetRq;
        })();

        Lobby.HeartBetRs = (function() {

            /**
             * Properties of a HeartBetRs.
             * @memberof Lobby.Lobby
             * @interface IHeartBetRs
             * @property {number|Long|null} [timeInfo] HeartBetRs timeInfo
             * @property {number|null} [timeOffset] HeartBetRs timeOffset
             */

            /**
             * Constructs a new HeartBetRs.
             * @memberof Lobby.Lobby
             * @classdesc Represents a HeartBetRs.
             * @implements IHeartBetRs
             * @constructor
             * @param {Lobby.Lobby.IHeartBetRs=} [properties] Properties to set
             */
            function HeartBetRs(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * HeartBetRs timeInfo.
             * @member {number|Long} timeInfo
             * @memberof Lobby.Lobby.HeartBetRs
             * @instance
             */
            HeartBetRs.prototype.timeInfo = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * HeartBetRs timeOffset.
             * @member {number} timeOffset
             * @memberof Lobby.Lobby.HeartBetRs
             * @instance
             */
            HeartBetRs.prototype.timeOffset = 0;

            /**
             * Creates a new HeartBetRs instance using the specified properties.
             * @function create
             * @memberof Lobby.Lobby.HeartBetRs
             * @static
             * @param {Lobby.Lobby.IHeartBetRs=} [properties] Properties to set
             * @returns {Lobby.Lobby.HeartBetRs} HeartBetRs instance
             */
            HeartBetRs.create = function create(properties) {
                return new HeartBetRs(properties);
            };

            /**
             * Encodes the specified HeartBetRs message. Does not implicitly {@link Lobby.Lobby.HeartBetRs.verify|verify} messages.
             * @function encode
             * @memberof Lobby.Lobby.HeartBetRs
             * @static
             * @param {Lobby.Lobby.IHeartBetRs} message HeartBetRs message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            HeartBetRs.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.timeInfo != null && Object.hasOwnProperty.call(message, "timeInfo"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.timeInfo);
                if (message.timeOffset != null && Object.hasOwnProperty.call(message, "timeOffset"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.timeOffset);
                return writer;
            };

            /**
             * Encodes the specified HeartBetRs message, length delimited. Does not implicitly {@link Lobby.Lobby.HeartBetRs.verify|verify} messages.
             * @function encodeDelimited
             * @memberof Lobby.Lobby.HeartBetRs
             * @static
             * @param {Lobby.Lobby.IHeartBetRs} message HeartBetRs message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            HeartBetRs.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a HeartBetRs message from the specified reader or buffer.
             * @function decode
             * @memberof Lobby.Lobby.HeartBetRs
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {Lobby.Lobby.HeartBetRs} HeartBetRs
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            HeartBetRs.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Lobby.Lobby.HeartBetRs();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.timeInfo = reader.int64();
                            break;
                        }
                    case 2: {
                            message.timeOffset = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a HeartBetRs message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof Lobby.Lobby.HeartBetRs
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {Lobby.Lobby.HeartBetRs} HeartBetRs
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            HeartBetRs.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a HeartBetRs message.
             * @function verify
             * @memberof Lobby.Lobby.HeartBetRs
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            HeartBetRs.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.timeInfo != null && message.hasOwnProperty("timeInfo"))
                    if (!$util.isInteger(message.timeInfo) && !(message.timeInfo && $util.isInteger(message.timeInfo.low) && $util.isInteger(message.timeInfo.high)))
                        return "timeInfo: integer|Long expected";
                if (message.timeOffset != null && message.hasOwnProperty("timeOffset"))
                    if (!$util.isInteger(message.timeOffset))
                        return "timeOffset: integer expected";
                return null;
            };

            /**
             * Creates a HeartBetRs message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof Lobby.Lobby.HeartBetRs
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {Lobby.Lobby.HeartBetRs} HeartBetRs
             */
            HeartBetRs.fromObject = function fromObject(object) {
                if (object instanceof $root.Lobby.Lobby.HeartBetRs)
                    return object;
                var message = new $root.Lobby.Lobby.HeartBetRs();
                if (object.timeInfo != null)
                    if ($util.Long)
                        (message.timeInfo = $util.Long.fromValue(object.timeInfo)).unsigned = false;
                    else if (typeof object.timeInfo === "string")
                        message.timeInfo = parseInt(object.timeInfo, 10);
                    else if (typeof object.timeInfo === "number")
                        message.timeInfo = object.timeInfo;
                    else if (typeof object.timeInfo === "object")
                        message.timeInfo = new $util.LongBits(object.timeInfo.low >>> 0, object.timeInfo.high >>> 0).toNumber();
                if (object.timeOffset != null)
                    message.timeOffset = object.timeOffset | 0;
                return message;
            };

            /**
             * Creates a plain object from a HeartBetRs message. Also converts values to other types if specified.
             * @function toObject
             * @memberof Lobby.Lobby.HeartBetRs
             * @static
             * @param {Lobby.Lobby.HeartBetRs} message HeartBetRs
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            HeartBetRs.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.timeInfo = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.timeInfo = options.longs === String ? "0" : 0;
                    object.timeOffset = 0;
                }
                if (message.timeInfo != null && message.hasOwnProperty("timeInfo"))
                    if (typeof message.timeInfo === "number")
                        object.timeInfo = options.longs === String ? String(message.timeInfo) : message.timeInfo;
                    else
                        object.timeInfo = options.longs === String ? $util.Long.prototype.toString.call(message.timeInfo) : options.longs === Number ? new $util.LongBits(message.timeInfo.low >>> 0, message.timeInfo.high >>> 0).toNumber() : message.timeInfo;
                if (message.timeOffset != null && message.hasOwnProperty("timeOffset"))
                    object.timeOffset = message.timeOffset;
                return object;
            };

            /**
             * Converts this HeartBetRs to JSON.
             * @function toJSON
             * @memberof Lobby.Lobby.HeartBetRs
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            HeartBetRs.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for HeartBetRs
             * @function getTypeUrl
             * @memberof Lobby.Lobby.HeartBetRs
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            HeartBetRs.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/Lobby.Lobby.HeartBetRs";
            };

            return HeartBetRs;
        })();

        Lobby.BalanceChangeNotifyMc = (function() {

            /**
             * Properties of a BalanceChangeNotifyMc.
             * @memberof Lobby.Lobby
             * @interface IBalanceChangeNotifyMc
             * @property {string|null} [tradeModeCode] BalanceChangeNotifyMc tradeModeCode
             * @property {string|null} [currencyType] BalanceChangeNotifyMc currencyType
             * @property {number|Long|null} [money] BalanceChangeNotifyMc money
             * @property {number|Long|null} [changedMoney] BalanceChangeNotifyMc changedMoney
             */

            /**
             * Constructs a new BalanceChangeNotifyMc.
             * @memberof Lobby.Lobby
             * @classdesc Represents a BalanceChangeNotifyMc.
             * @implements IBalanceChangeNotifyMc
             * @constructor
             * @param {Lobby.Lobby.IBalanceChangeNotifyMc=} [properties] Properties to set
             */
            function BalanceChangeNotifyMc(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BalanceChangeNotifyMc tradeModeCode.
             * @member {string} tradeModeCode
             * @memberof Lobby.Lobby.BalanceChangeNotifyMc
             * @instance
             */
            BalanceChangeNotifyMc.prototype.tradeModeCode = "";

            /**
             * BalanceChangeNotifyMc currencyType.
             * @member {string} currencyType
             * @memberof Lobby.Lobby.BalanceChangeNotifyMc
             * @instance
             */
            BalanceChangeNotifyMc.prototype.currencyType = "";

            /**
             * BalanceChangeNotifyMc money.
             * @member {number|Long} money
             * @memberof Lobby.Lobby.BalanceChangeNotifyMc
             * @instance
             */
            BalanceChangeNotifyMc.prototype.money = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * BalanceChangeNotifyMc changedMoney.
             * @member {number|Long} changedMoney
             * @memberof Lobby.Lobby.BalanceChangeNotifyMc
             * @instance
             */
            BalanceChangeNotifyMc.prototype.changedMoney = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new BalanceChangeNotifyMc instance using the specified properties.
             * @function create
             * @memberof Lobby.Lobby.BalanceChangeNotifyMc
             * @static
             * @param {Lobby.Lobby.IBalanceChangeNotifyMc=} [properties] Properties to set
             * @returns {Lobby.Lobby.BalanceChangeNotifyMc} BalanceChangeNotifyMc instance
             */
            BalanceChangeNotifyMc.create = function create(properties) {
                return new BalanceChangeNotifyMc(properties);
            };

            /**
             * Encodes the specified BalanceChangeNotifyMc message. Does not implicitly {@link Lobby.Lobby.BalanceChangeNotifyMc.verify|verify} messages.
             * @function encode
             * @memberof Lobby.Lobby.BalanceChangeNotifyMc
             * @static
             * @param {Lobby.Lobby.IBalanceChangeNotifyMc} message BalanceChangeNotifyMc message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BalanceChangeNotifyMc.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.tradeModeCode != null && Object.hasOwnProperty.call(message, "tradeModeCode"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.tradeModeCode);
                if (message.currencyType != null && Object.hasOwnProperty.call(message, "currencyType"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.currencyType);
                if (message.money != null && Object.hasOwnProperty.call(message, "money"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int64(message.money);
                if (message.changedMoney != null && Object.hasOwnProperty.call(message, "changedMoney"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int64(message.changedMoney);
                return writer;
            };

            /**
             * Encodes the specified BalanceChangeNotifyMc message, length delimited. Does not implicitly {@link Lobby.Lobby.BalanceChangeNotifyMc.verify|verify} messages.
             * @function encodeDelimited
             * @memberof Lobby.Lobby.BalanceChangeNotifyMc
             * @static
             * @param {Lobby.Lobby.IBalanceChangeNotifyMc} message BalanceChangeNotifyMc message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BalanceChangeNotifyMc.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BalanceChangeNotifyMc message from the specified reader or buffer.
             * @function decode
             * @memberof Lobby.Lobby.BalanceChangeNotifyMc
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {Lobby.Lobby.BalanceChangeNotifyMc} BalanceChangeNotifyMc
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BalanceChangeNotifyMc.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Lobby.Lobby.BalanceChangeNotifyMc();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.tradeModeCode = reader.string();
                            break;
                        }
                    case 2: {
                            message.currencyType = reader.string();
                            break;
                        }
                    case 3: {
                            message.money = reader.int64();
                            break;
                        }
                    case 4: {
                            message.changedMoney = reader.int64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BalanceChangeNotifyMc message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof Lobby.Lobby.BalanceChangeNotifyMc
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {Lobby.Lobby.BalanceChangeNotifyMc} BalanceChangeNotifyMc
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BalanceChangeNotifyMc.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BalanceChangeNotifyMc message.
             * @function verify
             * @memberof Lobby.Lobby.BalanceChangeNotifyMc
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BalanceChangeNotifyMc.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.tradeModeCode != null && message.hasOwnProperty("tradeModeCode"))
                    if (!$util.isString(message.tradeModeCode))
                        return "tradeModeCode: string expected";
                if (message.currencyType != null && message.hasOwnProperty("currencyType"))
                    if (!$util.isString(message.currencyType))
                        return "currencyType: string expected";
                if (message.money != null && message.hasOwnProperty("money"))
                    if (!$util.isInteger(message.money) && !(message.money && $util.isInteger(message.money.low) && $util.isInteger(message.money.high)))
                        return "money: integer|Long expected";
                if (message.changedMoney != null && message.hasOwnProperty("changedMoney"))
                    if (!$util.isInteger(message.changedMoney) && !(message.changedMoney && $util.isInteger(message.changedMoney.low) && $util.isInteger(message.changedMoney.high)))
                        return "changedMoney: integer|Long expected";
                return null;
            };

            /**
             * Creates a BalanceChangeNotifyMc message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof Lobby.Lobby.BalanceChangeNotifyMc
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {Lobby.Lobby.BalanceChangeNotifyMc} BalanceChangeNotifyMc
             */
            BalanceChangeNotifyMc.fromObject = function fromObject(object) {
                if (object instanceof $root.Lobby.Lobby.BalanceChangeNotifyMc)
                    return object;
                var message = new $root.Lobby.Lobby.BalanceChangeNotifyMc();
                if (object.tradeModeCode != null)
                    message.tradeModeCode = String(object.tradeModeCode);
                if (object.currencyType != null)
                    message.currencyType = String(object.currencyType);
                if (object.money != null)
                    if ($util.Long)
                        (message.money = $util.Long.fromValue(object.money)).unsigned = false;
                    else if (typeof object.money === "string")
                        message.money = parseInt(object.money, 10);
                    else if (typeof object.money === "number")
                        message.money = object.money;
                    else if (typeof object.money === "object")
                        message.money = new $util.LongBits(object.money.low >>> 0, object.money.high >>> 0).toNumber();
                if (object.changedMoney != null)
                    if ($util.Long)
                        (message.changedMoney = $util.Long.fromValue(object.changedMoney)).unsigned = false;
                    else if (typeof object.changedMoney === "string")
                        message.changedMoney = parseInt(object.changedMoney, 10);
                    else if (typeof object.changedMoney === "number")
                        message.changedMoney = object.changedMoney;
                    else if (typeof object.changedMoney === "object")
                        message.changedMoney = new $util.LongBits(object.changedMoney.low >>> 0, object.changedMoney.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a BalanceChangeNotifyMc message. Also converts values to other types if specified.
             * @function toObject
             * @memberof Lobby.Lobby.BalanceChangeNotifyMc
             * @static
             * @param {Lobby.Lobby.BalanceChangeNotifyMc} message BalanceChangeNotifyMc
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BalanceChangeNotifyMc.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.tradeModeCode = "";
                    object.currencyType = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.money = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.money = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.changedMoney = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.changedMoney = options.longs === String ? "0" : 0;
                }
                if (message.tradeModeCode != null && message.hasOwnProperty("tradeModeCode"))
                    object.tradeModeCode = message.tradeModeCode;
                if (message.currencyType != null && message.hasOwnProperty("currencyType"))
                    object.currencyType = message.currencyType;
                if (message.money != null && message.hasOwnProperty("money"))
                    if (typeof message.money === "number")
                        object.money = options.longs === String ? String(message.money) : message.money;
                    else
                        object.money = options.longs === String ? $util.Long.prototype.toString.call(message.money) : options.longs === Number ? new $util.LongBits(message.money.low >>> 0, message.money.high >>> 0).toNumber() : message.money;
                if (message.changedMoney != null && message.hasOwnProperty("changedMoney"))
                    if (typeof message.changedMoney === "number")
                        object.changedMoney = options.longs === String ? String(message.changedMoney) : message.changedMoney;
                    else
                        object.changedMoney = options.longs === String ? $util.Long.prototype.toString.call(message.changedMoney) : options.longs === Number ? new $util.LongBits(message.changedMoney.low >>> 0, message.changedMoney.high >>> 0).toNumber() : message.changedMoney;
                return object;
            };

            /**
             * Converts this BalanceChangeNotifyMc to JSON.
             * @function toJSON
             * @memberof Lobby.Lobby.BalanceChangeNotifyMc
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BalanceChangeNotifyMc.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for BalanceChangeNotifyMc
             * @function getTypeUrl
             * @memberof Lobby.Lobby.BalanceChangeNotifyMc
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            BalanceChangeNotifyMc.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/Lobby.Lobby.BalanceChangeNotifyMc";
            };

            return BalanceChangeNotifyMc;
        })();

        Lobby.NewEmailMc = (function() {

            /**
             * Properties of a NewEmailMc.
             * @memberof Lobby.Lobby
             * @interface INewEmailMc
             */

            /**
             * Constructs a new NewEmailMc.
             * @memberof Lobby.Lobby
             * @classdesc Represents a NewEmailMc.
             * @implements INewEmailMc
             * @constructor
             * @param {Lobby.Lobby.INewEmailMc=} [properties] Properties to set
             */
            function NewEmailMc(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new NewEmailMc instance using the specified properties.
             * @function create
             * @memberof Lobby.Lobby.NewEmailMc
             * @static
             * @param {Lobby.Lobby.INewEmailMc=} [properties] Properties to set
             * @returns {Lobby.Lobby.NewEmailMc} NewEmailMc instance
             */
            NewEmailMc.create = function create(properties) {
                return new NewEmailMc(properties);
            };

            /**
             * Encodes the specified NewEmailMc message. Does not implicitly {@link Lobby.Lobby.NewEmailMc.verify|verify} messages.
             * @function encode
             * @memberof Lobby.Lobby.NewEmailMc
             * @static
             * @param {Lobby.Lobby.INewEmailMc} message NewEmailMc message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            NewEmailMc.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified NewEmailMc message, length delimited. Does not implicitly {@link Lobby.Lobby.NewEmailMc.verify|verify} messages.
             * @function encodeDelimited
             * @memberof Lobby.Lobby.NewEmailMc
             * @static
             * @param {Lobby.Lobby.INewEmailMc} message NewEmailMc message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            NewEmailMc.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a NewEmailMc message from the specified reader or buffer.
             * @function decode
             * @memberof Lobby.Lobby.NewEmailMc
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {Lobby.Lobby.NewEmailMc} NewEmailMc
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            NewEmailMc.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Lobby.Lobby.NewEmailMc();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a NewEmailMc message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof Lobby.Lobby.NewEmailMc
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {Lobby.Lobby.NewEmailMc} NewEmailMc
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            NewEmailMc.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a NewEmailMc message.
             * @function verify
             * @memberof Lobby.Lobby.NewEmailMc
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            NewEmailMc.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a NewEmailMc message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof Lobby.Lobby.NewEmailMc
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {Lobby.Lobby.NewEmailMc} NewEmailMc
             */
            NewEmailMc.fromObject = function fromObject(object) {
                if (object instanceof $root.Lobby.Lobby.NewEmailMc)
                    return object;
                return new $root.Lobby.Lobby.NewEmailMc();
            };

            /**
             * Creates a plain object from a NewEmailMc message. Also converts values to other types if specified.
             * @function toObject
             * @memberof Lobby.Lobby.NewEmailMc
             * @static
             * @param {Lobby.Lobby.NewEmailMc} message NewEmailMc
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            NewEmailMc.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this NewEmailMc to JSON.
             * @function toJSON
             * @memberof Lobby.Lobby.NewEmailMc
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            NewEmailMc.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for NewEmailMc
             * @function getTypeUrl
             * @memberof Lobby.Lobby.NewEmailMc
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            NewEmailMc.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/Lobby.Lobby.NewEmailMc";
            };

            return NewEmailMc;
        })();

        Lobby.LoginOutMc = (function() {

            /**
             * Properties of a LoginOutMc.
             * @memberof Lobby.Lobby
             * @interface ILoginOutMc
             */

            /**
             * Constructs a new LoginOutMc.
             * @memberof Lobby.Lobby
             * @classdesc Represents a LoginOutMc.
             * @implements ILoginOutMc
             * @constructor
             * @param {Lobby.Lobby.ILoginOutMc=} [properties] Properties to set
             */
            function LoginOutMc(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new LoginOutMc instance using the specified properties.
             * @function create
             * @memberof Lobby.Lobby.LoginOutMc
             * @static
             * @param {Lobby.Lobby.ILoginOutMc=} [properties] Properties to set
             * @returns {Lobby.Lobby.LoginOutMc} LoginOutMc instance
             */
            LoginOutMc.create = function create(properties) {
                return new LoginOutMc(properties);
            };

            /**
             * Encodes the specified LoginOutMc message. Does not implicitly {@link Lobby.Lobby.LoginOutMc.verify|verify} messages.
             * @function encode
             * @memberof Lobby.Lobby.LoginOutMc
             * @static
             * @param {Lobby.Lobby.ILoginOutMc} message LoginOutMc message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LoginOutMc.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified LoginOutMc message, length delimited. Does not implicitly {@link Lobby.Lobby.LoginOutMc.verify|verify} messages.
             * @function encodeDelimited
             * @memberof Lobby.Lobby.LoginOutMc
             * @static
             * @param {Lobby.Lobby.ILoginOutMc} message LoginOutMc message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LoginOutMc.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a LoginOutMc message from the specified reader or buffer.
             * @function decode
             * @memberof Lobby.Lobby.LoginOutMc
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {Lobby.Lobby.LoginOutMc} LoginOutMc
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LoginOutMc.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Lobby.Lobby.LoginOutMc();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a LoginOutMc message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof Lobby.Lobby.LoginOutMc
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {Lobby.Lobby.LoginOutMc} LoginOutMc
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LoginOutMc.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a LoginOutMc message.
             * @function verify
             * @memberof Lobby.Lobby.LoginOutMc
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            LoginOutMc.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a LoginOutMc message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof Lobby.Lobby.LoginOutMc
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {Lobby.Lobby.LoginOutMc} LoginOutMc
             */
            LoginOutMc.fromObject = function fromObject(object) {
                if (object instanceof $root.Lobby.Lobby.LoginOutMc)
                    return object;
                return new $root.Lobby.Lobby.LoginOutMc();
            };

            /**
             * Creates a plain object from a LoginOutMc message. Also converts values to other types if specified.
             * @function toObject
             * @memberof Lobby.Lobby.LoginOutMc
             * @static
             * @param {Lobby.Lobby.LoginOutMc} message LoginOutMc
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            LoginOutMc.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this LoginOutMc to JSON.
             * @function toJSON
             * @memberof Lobby.Lobby.LoginOutMc
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            LoginOutMc.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for LoginOutMc
             * @function getTypeUrl
             * @memberof Lobby.Lobby.LoginOutMc
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            LoginOutMc.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/Lobby.Lobby.LoginOutMc";
            };

            return LoginOutMc;
        })();

        Lobby.TaskFinishMc = (function() {

            /**
             * Properties of a TaskFinishMc.
             * @memberof Lobby.Lobby
             * @interface ITaskFinishMc
             */

            /**
             * Constructs a new TaskFinishMc.
             * @memberof Lobby.Lobby
             * @classdesc Represents a TaskFinishMc.
             * @implements ITaskFinishMc
             * @constructor
             * @param {Lobby.Lobby.ITaskFinishMc=} [properties] Properties to set
             */
            function TaskFinishMc(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new TaskFinishMc instance using the specified properties.
             * @function create
             * @memberof Lobby.Lobby.TaskFinishMc
             * @static
             * @param {Lobby.Lobby.ITaskFinishMc=} [properties] Properties to set
             * @returns {Lobby.Lobby.TaskFinishMc} TaskFinishMc instance
             */
            TaskFinishMc.create = function create(properties) {
                return new TaskFinishMc(properties);
            };

            /**
             * Encodes the specified TaskFinishMc message. Does not implicitly {@link Lobby.Lobby.TaskFinishMc.verify|verify} messages.
             * @function encode
             * @memberof Lobby.Lobby.TaskFinishMc
             * @static
             * @param {Lobby.Lobby.ITaskFinishMc} message TaskFinishMc message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TaskFinishMc.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified TaskFinishMc message, length delimited. Does not implicitly {@link Lobby.Lobby.TaskFinishMc.verify|verify} messages.
             * @function encodeDelimited
             * @memberof Lobby.Lobby.TaskFinishMc
             * @static
             * @param {Lobby.Lobby.ITaskFinishMc} message TaskFinishMc message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TaskFinishMc.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a TaskFinishMc message from the specified reader or buffer.
             * @function decode
             * @memberof Lobby.Lobby.TaskFinishMc
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {Lobby.Lobby.TaskFinishMc} TaskFinishMc
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TaskFinishMc.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Lobby.Lobby.TaskFinishMc();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a TaskFinishMc message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof Lobby.Lobby.TaskFinishMc
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {Lobby.Lobby.TaskFinishMc} TaskFinishMc
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TaskFinishMc.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a TaskFinishMc message.
             * @function verify
             * @memberof Lobby.Lobby.TaskFinishMc
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            TaskFinishMc.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a TaskFinishMc message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof Lobby.Lobby.TaskFinishMc
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {Lobby.Lobby.TaskFinishMc} TaskFinishMc
             */
            TaskFinishMc.fromObject = function fromObject(object) {
                if (object instanceof $root.Lobby.Lobby.TaskFinishMc)
                    return object;
                return new $root.Lobby.Lobby.TaskFinishMc();
            };

            /**
             * Creates a plain object from a TaskFinishMc message. Also converts values to other types if specified.
             * @function toObject
             * @memberof Lobby.Lobby.TaskFinishMc
             * @static
             * @param {Lobby.Lobby.TaskFinishMc} message TaskFinishMc
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            TaskFinishMc.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this TaskFinishMc to JSON.
             * @function toJSON
             * @memberof Lobby.Lobby.TaskFinishMc
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            TaskFinishMc.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for TaskFinishMc
             * @function getTypeUrl
             * @memberof Lobby.Lobby.TaskFinishMc
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            TaskFinishMc.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/Lobby.Lobby.TaskFinishMc";
            };

            return TaskFinishMc;
        })();

        Lobby.ConfigChangeMc = (function() {

            /**
             * Properties of a ConfigChangeMc.
             * @memberof Lobby.Lobby
             * @interface IConfigChangeMc
             * @property {string|null} [message] ConfigChangeMc message
             */

            /**
             * Constructs a new ConfigChangeMc.
             * @memberof Lobby.Lobby
             * @classdesc Represents a ConfigChangeMc.
             * @implements IConfigChangeMc
             * @constructor
             * @param {Lobby.Lobby.IConfigChangeMc=} [properties] Properties to set
             */
            function ConfigChangeMc(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ConfigChangeMc message.
             * @member {string} message
             * @memberof Lobby.Lobby.ConfigChangeMc
             * @instance
             */
            ConfigChangeMc.prototype.message = "";

            /**
             * Creates a new ConfigChangeMc instance using the specified properties.
             * @function create
             * @memberof Lobby.Lobby.ConfigChangeMc
             * @static
             * @param {Lobby.Lobby.IConfigChangeMc=} [properties] Properties to set
             * @returns {Lobby.Lobby.ConfigChangeMc} ConfigChangeMc instance
             */
            ConfigChangeMc.create = function create(properties) {
                return new ConfigChangeMc(properties);
            };

            /**
             * Encodes the specified ConfigChangeMc message. Does not implicitly {@link Lobby.Lobby.ConfigChangeMc.verify|verify} messages.
             * @function encode
             * @memberof Lobby.Lobby.ConfigChangeMc
             * @static
             * @param {Lobby.Lobby.IConfigChangeMc} message ConfigChangeMc message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ConfigChangeMc.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.message);
                return writer;
            };

            /**
             * Encodes the specified ConfigChangeMc message, length delimited. Does not implicitly {@link Lobby.Lobby.ConfigChangeMc.verify|verify} messages.
             * @function encodeDelimited
             * @memberof Lobby.Lobby.ConfigChangeMc
             * @static
             * @param {Lobby.Lobby.IConfigChangeMc} message ConfigChangeMc message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ConfigChangeMc.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ConfigChangeMc message from the specified reader or buffer.
             * @function decode
             * @memberof Lobby.Lobby.ConfigChangeMc
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {Lobby.Lobby.ConfigChangeMc} ConfigChangeMc
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ConfigChangeMc.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Lobby.Lobby.ConfigChangeMc();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.message = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ConfigChangeMc message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof Lobby.Lobby.ConfigChangeMc
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {Lobby.Lobby.ConfigChangeMc} ConfigChangeMc
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ConfigChangeMc.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ConfigChangeMc message.
             * @function verify
             * @memberof Lobby.Lobby.ConfigChangeMc
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ConfigChangeMc.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.message != null && message.hasOwnProperty("message"))
                    if (!$util.isString(message.message))
                        return "message: string expected";
                return null;
            };

            /**
             * Creates a ConfigChangeMc message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof Lobby.Lobby.ConfigChangeMc
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {Lobby.Lobby.ConfigChangeMc} ConfigChangeMc
             */
            ConfigChangeMc.fromObject = function fromObject(object) {
                if (object instanceof $root.Lobby.Lobby.ConfigChangeMc)
                    return object;
                var message = new $root.Lobby.Lobby.ConfigChangeMc();
                if (object.message != null)
                    message.message = String(object.message);
                return message;
            };

            /**
             * Creates a plain object from a ConfigChangeMc message. Also converts values to other types if specified.
             * @function toObject
             * @memberof Lobby.Lobby.ConfigChangeMc
             * @static
             * @param {Lobby.Lobby.ConfigChangeMc} message ConfigChangeMc
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ConfigChangeMc.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.message = "";
                if (message.message != null && message.hasOwnProperty("message"))
                    object.message = message.message;
                return object;
            };

            /**
             * Converts this ConfigChangeMc to JSON.
             * @function toJSON
             * @memberof Lobby.Lobby.ConfigChangeMc
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ConfigChangeMc.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ConfigChangeMc
             * @function getTypeUrl
             * @memberof Lobby.Lobby.ConfigChangeMc
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ConfigChangeMc.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/Lobby.Lobby.ConfigChangeMc";
            };

            return ConfigChangeMc;
        })();

        Lobby.BetGameNotifyMc = (function() {

            /**
             * Properties of a BetGameNotifyMc.
             * @memberof Lobby.Lobby
             * @interface IBetGameNotifyMc
             * @property {number|null} [gameId] BetGameNotifyMc gameId
             * @property {number|Long|null} [betAmount] BetGameNotifyMc betAmount
             * @property {string|null} [betId] BetGameNotifyMc betId
             * @property {string|null} [betResult] BetGameNotifyMc betResult
             * @property {number|Long|null} [betTime] BetGameNotifyMc betTime
             * @property {string|null} [currencyType] BetGameNotifyMc currencyType
             * @property {string|null} [payout] BetGameNotifyMc payout
             * @property {number|Long|null} [playerAmount] BetGameNotifyMc playerAmount
             * @property {number|Long|null} [settleTime] BetGameNotifyMc settleTime
             * @property {number|null} [userId] BetGameNotifyMc userId
             * @property {string|null} [userName] BetGameNotifyMc userName
             * @property {number|Long|null} [winAmount] BetGameNotifyMc winAmount
             */

            /**
             * Constructs a new BetGameNotifyMc.
             * @memberof Lobby.Lobby
             * @classdesc Represents a BetGameNotifyMc.
             * @implements IBetGameNotifyMc
             * @constructor
             * @param {Lobby.Lobby.IBetGameNotifyMc=} [properties] Properties to set
             */
            function BetGameNotifyMc(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BetGameNotifyMc gameId.
             * @member {number} gameId
             * @memberof Lobby.Lobby.BetGameNotifyMc
             * @instance
             */
            BetGameNotifyMc.prototype.gameId = 0;

            /**
             * BetGameNotifyMc betAmount.
             * @member {number|Long} betAmount
             * @memberof Lobby.Lobby.BetGameNotifyMc
             * @instance
             */
            BetGameNotifyMc.prototype.betAmount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * BetGameNotifyMc betId.
             * @member {string} betId
             * @memberof Lobby.Lobby.BetGameNotifyMc
             * @instance
             */
            BetGameNotifyMc.prototype.betId = "";

            /**
             * BetGameNotifyMc betResult.
             * @member {string} betResult
             * @memberof Lobby.Lobby.BetGameNotifyMc
             * @instance
             */
            BetGameNotifyMc.prototype.betResult = "";

            /**
             * BetGameNotifyMc betTime.
             * @member {number|Long} betTime
             * @memberof Lobby.Lobby.BetGameNotifyMc
             * @instance
             */
            BetGameNotifyMc.prototype.betTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * BetGameNotifyMc currencyType.
             * @member {string} currencyType
             * @memberof Lobby.Lobby.BetGameNotifyMc
             * @instance
             */
            BetGameNotifyMc.prototype.currencyType = "";

            /**
             * BetGameNotifyMc payout.
             * @member {string} payout
             * @memberof Lobby.Lobby.BetGameNotifyMc
             * @instance
             */
            BetGameNotifyMc.prototype.payout = "";

            /**
             * BetGameNotifyMc playerAmount.
             * @member {number|Long} playerAmount
             * @memberof Lobby.Lobby.BetGameNotifyMc
             * @instance
             */
            BetGameNotifyMc.prototype.playerAmount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * BetGameNotifyMc settleTime.
             * @member {number|Long} settleTime
             * @memberof Lobby.Lobby.BetGameNotifyMc
             * @instance
             */
            BetGameNotifyMc.prototype.settleTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * BetGameNotifyMc userId.
             * @member {number} userId
             * @memberof Lobby.Lobby.BetGameNotifyMc
             * @instance
             */
            BetGameNotifyMc.prototype.userId = 0;

            /**
             * BetGameNotifyMc userName.
             * @member {string} userName
             * @memberof Lobby.Lobby.BetGameNotifyMc
             * @instance
             */
            BetGameNotifyMc.prototype.userName = "";

            /**
             * BetGameNotifyMc winAmount.
             * @member {number|Long} winAmount
             * @memberof Lobby.Lobby.BetGameNotifyMc
             * @instance
             */
            BetGameNotifyMc.prototype.winAmount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new BetGameNotifyMc instance using the specified properties.
             * @function create
             * @memberof Lobby.Lobby.BetGameNotifyMc
             * @static
             * @param {Lobby.Lobby.IBetGameNotifyMc=} [properties] Properties to set
             * @returns {Lobby.Lobby.BetGameNotifyMc} BetGameNotifyMc instance
             */
            BetGameNotifyMc.create = function create(properties) {
                return new BetGameNotifyMc(properties);
            };

            /**
             * Encodes the specified BetGameNotifyMc message. Does not implicitly {@link Lobby.Lobby.BetGameNotifyMc.verify|verify} messages.
             * @function encode
             * @memberof Lobby.Lobby.BetGameNotifyMc
             * @static
             * @param {Lobby.Lobby.IBetGameNotifyMc} message BetGameNotifyMc message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BetGameNotifyMc.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.gameId != null && Object.hasOwnProperty.call(message, "gameId"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.gameId);
                if (message.betAmount != null && Object.hasOwnProperty.call(message, "betAmount"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.betAmount);
                if (message.betId != null && Object.hasOwnProperty.call(message, "betId"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.betId);
                if (message.betResult != null && Object.hasOwnProperty.call(message, "betResult"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.betResult);
                if (message.betTime != null && Object.hasOwnProperty.call(message, "betTime"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int64(message.betTime);
                if (message.currencyType != null && Object.hasOwnProperty.call(message, "currencyType"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.currencyType);
                if (message.payout != null && Object.hasOwnProperty.call(message, "payout"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.payout);
                if (message.playerAmount != null && Object.hasOwnProperty.call(message, "playerAmount"))
                    writer.uint32(/* id 8, wireType 0 =*/64).int64(message.playerAmount);
                if (message.settleTime != null && Object.hasOwnProperty.call(message, "settleTime"))
                    writer.uint32(/* id 9, wireType 0 =*/72).int64(message.settleTime);
                if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                    writer.uint32(/* id 10, wireType 0 =*/80).int32(message.userId);
                if (message.userName != null && Object.hasOwnProperty.call(message, "userName"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.userName);
                if (message.winAmount != null && Object.hasOwnProperty.call(message, "winAmount"))
                    writer.uint32(/* id 12, wireType 0 =*/96).int64(message.winAmount);
                return writer;
            };

            /**
             * Encodes the specified BetGameNotifyMc message, length delimited. Does not implicitly {@link Lobby.Lobby.BetGameNotifyMc.verify|verify} messages.
             * @function encodeDelimited
             * @memberof Lobby.Lobby.BetGameNotifyMc
             * @static
             * @param {Lobby.Lobby.IBetGameNotifyMc} message BetGameNotifyMc message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BetGameNotifyMc.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BetGameNotifyMc message from the specified reader or buffer.
             * @function decode
             * @memberof Lobby.Lobby.BetGameNotifyMc
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {Lobby.Lobby.BetGameNotifyMc} BetGameNotifyMc
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BetGameNotifyMc.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Lobby.Lobby.BetGameNotifyMc();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.gameId = reader.int32();
                            break;
                        }
                    case 2: {
                            message.betAmount = reader.int64();
                            break;
                        }
                    case 3: {
                            message.betId = reader.string();
                            break;
                        }
                    case 4: {
                            message.betResult = reader.string();
                            break;
                        }
                    case 5: {
                            message.betTime = reader.int64();
                            break;
                        }
                    case 6: {
                            message.currencyType = reader.string();
                            break;
                        }
                    case 7: {
                            message.payout = reader.string();
                            break;
                        }
                    case 8: {
                            message.playerAmount = reader.int64();
                            break;
                        }
                    case 9: {
                            message.settleTime = reader.int64();
                            break;
                        }
                    case 10: {
                            message.userId = reader.int32();
                            break;
                        }
                    case 11: {
                            message.userName = reader.string();
                            break;
                        }
                    case 12: {
                            message.winAmount = reader.int64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BetGameNotifyMc message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof Lobby.Lobby.BetGameNotifyMc
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {Lobby.Lobby.BetGameNotifyMc} BetGameNotifyMc
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BetGameNotifyMc.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BetGameNotifyMc message.
             * @function verify
             * @memberof Lobby.Lobby.BetGameNotifyMc
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BetGameNotifyMc.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.gameId != null && message.hasOwnProperty("gameId"))
                    if (!$util.isInteger(message.gameId))
                        return "gameId: integer expected";
                if (message.betAmount != null && message.hasOwnProperty("betAmount"))
                    if (!$util.isInteger(message.betAmount) && !(message.betAmount && $util.isInteger(message.betAmount.low) && $util.isInteger(message.betAmount.high)))
                        return "betAmount: integer|Long expected";
                if (message.betId != null && message.hasOwnProperty("betId"))
                    if (!$util.isString(message.betId))
                        return "betId: string expected";
                if (message.betResult != null && message.hasOwnProperty("betResult"))
                    if (!$util.isString(message.betResult))
                        return "betResult: string expected";
                if (message.betTime != null && message.hasOwnProperty("betTime"))
                    if (!$util.isInteger(message.betTime) && !(message.betTime && $util.isInteger(message.betTime.low) && $util.isInteger(message.betTime.high)))
                        return "betTime: integer|Long expected";
                if (message.currencyType != null && message.hasOwnProperty("currencyType"))
                    if (!$util.isString(message.currencyType))
                        return "currencyType: string expected";
                if (message.payout != null && message.hasOwnProperty("payout"))
                    if (!$util.isString(message.payout))
                        return "payout: string expected";
                if (message.playerAmount != null && message.hasOwnProperty("playerAmount"))
                    if (!$util.isInteger(message.playerAmount) && !(message.playerAmount && $util.isInteger(message.playerAmount.low) && $util.isInteger(message.playerAmount.high)))
                        return "playerAmount: integer|Long expected";
                if (message.settleTime != null && message.hasOwnProperty("settleTime"))
                    if (!$util.isInteger(message.settleTime) && !(message.settleTime && $util.isInteger(message.settleTime.low) && $util.isInteger(message.settleTime.high)))
                        return "settleTime: integer|Long expected";
                if (message.userId != null && message.hasOwnProperty("userId"))
                    if (!$util.isInteger(message.userId))
                        return "userId: integer expected";
                if (message.userName != null && message.hasOwnProperty("userName"))
                    if (!$util.isString(message.userName))
                        return "userName: string expected";
                if (message.winAmount != null && message.hasOwnProperty("winAmount"))
                    if (!$util.isInteger(message.winAmount) && !(message.winAmount && $util.isInteger(message.winAmount.low) && $util.isInteger(message.winAmount.high)))
                        return "winAmount: integer|Long expected";
                return null;
            };

            /**
             * Creates a BetGameNotifyMc message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof Lobby.Lobby.BetGameNotifyMc
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {Lobby.Lobby.BetGameNotifyMc} BetGameNotifyMc
             */
            BetGameNotifyMc.fromObject = function fromObject(object) {
                if (object instanceof $root.Lobby.Lobby.BetGameNotifyMc)
                    return object;
                var message = new $root.Lobby.Lobby.BetGameNotifyMc();
                if (object.gameId != null)
                    message.gameId = object.gameId | 0;
                if (object.betAmount != null)
                    if ($util.Long)
                        (message.betAmount = $util.Long.fromValue(object.betAmount)).unsigned = false;
                    else if (typeof object.betAmount === "string")
                        message.betAmount = parseInt(object.betAmount, 10);
                    else if (typeof object.betAmount === "number")
                        message.betAmount = object.betAmount;
                    else if (typeof object.betAmount === "object")
                        message.betAmount = new $util.LongBits(object.betAmount.low >>> 0, object.betAmount.high >>> 0).toNumber();
                if (object.betId != null)
                    message.betId = String(object.betId);
                if (object.betResult != null)
                    message.betResult = String(object.betResult);
                if (object.betTime != null)
                    if ($util.Long)
                        (message.betTime = $util.Long.fromValue(object.betTime)).unsigned = false;
                    else if (typeof object.betTime === "string")
                        message.betTime = parseInt(object.betTime, 10);
                    else if (typeof object.betTime === "number")
                        message.betTime = object.betTime;
                    else if (typeof object.betTime === "object")
                        message.betTime = new $util.LongBits(object.betTime.low >>> 0, object.betTime.high >>> 0).toNumber();
                if (object.currencyType != null)
                    message.currencyType = String(object.currencyType);
                if (object.payout != null)
                    message.payout = String(object.payout);
                if (object.playerAmount != null)
                    if ($util.Long)
                        (message.playerAmount = $util.Long.fromValue(object.playerAmount)).unsigned = false;
                    else if (typeof object.playerAmount === "string")
                        message.playerAmount = parseInt(object.playerAmount, 10);
                    else if (typeof object.playerAmount === "number")
                        message.playerAmount = object.playerAmount;
                    else if (typeof object.playerAmount === "object")
                        message.playerAmount = new $util.LongBits(object.playerAmount.low >>> 0, object.playerAmount.high >>> 0).toNumber();
                if (object.settleTime != null)
                    if ($util.Long)
                        (message.settleTime = $util.Long.fromValue(object.settleTime)).unsigned = false;
                    else if (typeof object.settleTime === "string")
                        message.settleTime = parseInt(object.settleTime, 10);
                    else if (typeof object.settleTime === "number")
                        message.settleTime = object.settleTime;
                    else if (typeof object.settleTime === "object")
                        message.settleTime = new $util.LongBits(object.settleTime.low >>> 0, object.settleTime.high >>> 0).toNumber();
                if (object.userId != null)
                    message.userId = object.userId | 0;
                if (object.userName != null)
                    message.userName = String(object.userName);
                if (object.winAmount != null)
                    if ($util.Long)
                        (message.winAmount = $util.Long.fromValue(object.winAmount)).unsigned = false;
                    else if (typeof object.winAmount === "string")
                        message.winAmount = parseInt(object.winAmount, 10);
                    else if (typeof object.winAmount === "number")
                        message.winAmount = object.winAmount;
                    else if (typeof object.winAmount === "object")
                        message.winAmount = new $util.LongBits(object.winAmount.low >>> 0, object.winAmount.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a BetGameNotifyMc message. Also converts values to other types if specified.
             * @function toObject
             * @memberof Lobby.Lobby.BetGameNotifyMc
             * @static
             * @param {Lobby.Lobby.BetGameNotifyMc} message BetGameNotifyMc
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BetGameNotifyMc.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.gameId = 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.betAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.betAmount = options.longs === String ? "0" : 0;
                    object.betId = "";
                    object.betResult = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.betTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.betTime = options.longs === String ? "0" : 0;
                    object.currencyType = "";
                    object.payout = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.playerAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.playerAmount = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.settleTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.settleTime = options.longs === String ? "0" : 0;
                    object.userId = 0;
                    object.userName = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.winAmount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.winAmount = options.longs === String ? "0" : 0;
                }
                if (message.gameId != null && message.hasOwnProperty("gameId"))
                    object.gameId = message.gameId;
                if (message.betAmount != null && message.hasOwnProperty("betAmount"))
                    if (typeof message.betAmount === "number")
                        object.betAmount = options.longs === String ? String(message.betAmount) : message.betAmount;
                    else
                        object.betAmount = options.longs === String ? $util.Long.prototype.toString.call(message.betAmount) : options.longs === Number ? new $util.LongBits(message.betAmount.low >>> 0, message.betAmount.high >>> 0).toNumber() : message.betAmount;
                if (message.betId != null && message.hasOwnProperty("betId"))
                    object.betId = message.betId;
                if (message.betResult != null && message.hasOwnProperty("betResult"))
                    object.betResult = message.betResult;
                if (message.betTime != null && message.hasOwnProperty("betTime"))
                    if (typeof message.betTime === "number")
                        object.betTime = options.longs === String ? String(message.betTime) : message.betTime;
                    else
                        object.betTime = options.longs === String ? $util.Long.prototype.toString.call(message.betTime) : options.longs === Number ? new $util.LongBits(message.betTime.low >>> 0, message.betTime.high >>> 0).toNumber() : message.betTime;
                if (message.currencyType != null && message.hasOwnProperty("currencyType"))
                    object.currencyType = message.currencyType;
                if (message.payout != null && message.hasOwnProperty("payout"))
                    object.payout = message.payout;
                if (message.playerAmount != null && message.hasOwnProperty("playerAmount"))
                    if (typeof message.playerAmount === "number")
                        object.playerAmount = options.longs === String ? String(message.playerAmount) : message.playerAmount;
                    else
                        object.playerAmount = options.longs === String ? $util.Long.prototype.toString.call(message.playerAmount) : options.longs === Number ? new $util.LongBits(message.playerAmount.low >>> 0, message.playerAmount.high >>> 0).toNumber() : message.playerAmount;
                if (message.settleTime != null && message.hasOwnProperty("settleTime"))
                    if (typeof message.settleTime === "number")
                        object.settleTime = options.longs === String ? String(message.settleTime) : message.settleTime;
                    else
                        object.settleTime = options.longs === String ? $util.Long.prototype.toString.call(message.settleTime) : options.longs === Number ? new $util.LongBits(message.settleTime.low >>> 0, message.settleTime.high >>> 0).toNumber() : message.settleTime;
                if (message.userId != null && message.hasOwnProperty("userId"))
                    object.userId = message.userId;
                if (message.userName != null && message.hasOwnProperty("userName"))
                    object.userName = message.userName;
                if (message.winAmount != null && message.hasOwnProperty("winAmount"))
                    if (typeof message.winAmount === "number")
                        object.winAmount = options.longs === String ? String(message.winAmount) : message.winAmount;
                    else
                        object.winAmount = options.longs === String ? $util.Long.prototype.toString.call(message.winAmount) : options.longs === Number ? new $util.LongBits(message.winAmount.low >>> 0, message.winAmount.high >>> 0).toNumber() : message.winAmount;
                return object;
            };

            /**
             * Converts this BetGameNotifyMc to JSON.
             * @function toJSON
             * @memberof Lobby.Lobby.BetGameNotifyMc
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BetGameNotifyMc.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for BetGameNotifyMc
             * @function getTypeUrl
             * @memberof Lobby.Lobby.BetGameNotifyMc
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            BetGameNotifyMc.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/Lobby.Lobby.BetGameNotifyMc";
            };

            return BetGameNotifyMc;
        })();

        Lobby.InsufficientBalanceMc = (function() {

            /**
             * Properties of an InsufficientBalanceMc.
             * @memberof Lobby.Lobby
             * @interface IInsufficientBalanceMc
             */

            /**
             * Constructs a new InsufficientBalanceMc.
             * @memberof Lobby.Lobby
             * @classdesc Represents an InsufficientBalanceMc.
             * @implements IInsufficientBalanceMc
             * @constructor
             * @param {Lobby.Lobby.IInsufficientBalanceMc=} [properties] Properties to set
             */
            function InsufficientBalanceMc(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new InsufficientBalanceMc instance using the specified properties.
             * @function create
             * @memberof Lobby.Lobby.InsufficientBalanceMc
             * @static
             * @param {Lobby.Lobby.IInsufficientBalanceMc=} [properties] Properties to set
             * @returns {Lobby.Lobby.InsufficientBalanceMc} InsufficientBalanceMc instance
             */
            InsufficientBalanceMc.create = function create(properties) {
                return new InsufficientBalanceMc(properties);
            };

            /**
             * Encodes the specified InsufficientBalanceMc message. Does not implicitly {@link Lobby.Lobby.InsufficientBalanceMc.verify|verify} messages.
             * @function encode
             * @memberof Lobby.Lobby.InsufficientBalanceMc
             * @static
             * @param {Lobby.Lobby.IInsufficientBalanceMc} message InsufficientBalanceMc message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            InsufficientBalanceMc.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified InsufficientBalanceMc message, length delimited. Does not implicitly {@link Lobby.Lobby.InsufficientBalanceMc.verify|verify} messages.
             * @function encodeDelimited
             * @memberof Lobby.Lobby.InsufficientBalanceMc
             * @static
             * @param {Lobby.Lobby.IInsufficientBalanceMc} message InsufficientBalanceMc message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            InsufficientBalanceMc.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an InsufficientBalanceMc message from the specified reader or buffer.
             * @function decode
             * @memberof Lobby.Lobby.InsufficientBalanceMc
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {Lobby.Lobby.InsufficientBalanceMc} InsufficientBalanceMc
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            InsufficientBalanceMc.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Lobby.Lobby.InsufficientBalanceMc();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an InsufficientBalanceMc message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof Lobby.Lobby.InsufficientBalanceMc
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {Lobby.Lobby.InsufficientBalanceMc} InsufficientBalanceMc
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            InsufficientBalanceMc.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an InsufficientBalanceMc message.
             * @function verify
             * @memberof Lobby.Lobby.InsufficientBalanceMc
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            InsufficientBalanceMc.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an InsufficientBalanceMc message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof Lobby.Lobby.InsufficientBalanceMc
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {Lobby.Lobby.InsufficientBalanceMc} InsufficientBalanceMc
             */
            InsufficientBalanceMc.fromObject = function fromObject(object) {
                if (object instanceof $root.Lobby.Lobby.InsufficientBalanceMc)
                    return object;
                return new $root.Lobby.Lobby.InsufficientBalanceMc();
            };

            /**
             * Creates a plain object from an InsufficientBalanceMc message. Also converts values to other types if specified.
             * @function toObject
             * @memberof Lobby.Lobby.InsufficientBalanceMc
             * @static
             * @param {Lobby.Lobby.InsufficientBalanceMc} message InsufficientBalanceMc
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            InsufficientBalanceMc.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this InsufficientBalanceMc to JSON.
             * @function toJSON
             * @memberof Lobby.Lobby.InsufficientBalanceMc
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            InsufficientBalanceMc.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for InsufficientBalanceMc
             * @function getTypeUrl
             * @memberof Lobby.Lobby.InsufficientBalanceMc
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            InsufficientBalanceMc.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/Lobby.Lobby.InsufficientBalanceMc";
            };

            return InsufficientBalanceMc;
        })();

        return Lobby;
    })();

    return Lobby;
})();

module.exports = $root;
